import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../assets/icons/Group 26079.svg";
import filtericon from "../../assets/icons/Group 26123@2x.png";
import charticon from "../../assets/icons/Path 23145.svg";
import Prediction from "../../assets/icons/Prediction.png";
import UserPredictionListingComp from "../../components/userPredictionListing/userPredictionListingComp";
import { useDispatch, useSelector } from "react-redux";
import { getFollowedPredictionPost } from "../../redux/actions/pollingAction";
import NothingFound from "../../pages/search-result/NothingFound";
import PredictionContext from "../../context/predictionFlow/predictionContext";

const FollowedPrediction = () => {
  const [render, setRender] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [openCommentId, setOpenCommentId] = useState(null);
  const [openShareId, setOpenShareId] = useState(null);
  const { prediction, setPrediction } = useContext(PredictionContext);
  const [showFilter, setShowFilter] = useState({
    show: false,
    payload: [],
  });
  const navigate = useNavigate();

  const isVerified = localStorage.getItem("accessToken");
  useEffect(() => {
    if (!isVerified) {
      navigate("/login");
    }
  }, []);

  const submitFollowedPrediction = () => {
    dispatch(
      getFollowedPredictionPost({
        search: searchText,
        payload: showFilter.payload,
      })
    );
    setShowFilter({
      show: false,
      payload: [],
    });
  };

  const dispatch = useDispatch();
  useEffect(
    function gettingPredictionPost() {
      submitFollowedPrediction();
    },
    [render]
  );
  // console.log("name", showFilter);

  const handleFilter = (event) => {
    const { name, checked } = event.target;

    setShowFilter((prev) => ({
      ...prev,
      payload: checked
        ? [...prev.payload, name]
        : prev.payload.filter((item) => item !== name),
    }));
  };
  const handleApplyFilter = () => {
    if (showFilter.payload.length > 0) {
      submitFollowedPrediction();
    } else {
      alert("Please select atleast 1 value");
    }
  };

  const handleSearch = () => {
    if (searchText) {
      submitFollowedPrediction();
    }
  };
  const handleReset = () => {
    setShowFilter({
      show: false,
      payload: [],
    });
    setSearchText("");
    dispatch(
      getFollowedPredictionPost({
        search: "",
        payload: [],
      })
    );
  };
  const handleInput = (e) => {
    console.log(e.target.value);
    setSearchText(e.target.value);
  };
  const { FollowedPredictionPostListingResponse } = useSelector(
    (state) => state?.pollWeb
  );

  const filterRef = useRef(null);
  const handleNewPrediction = () => {
    setPrediction({ ...prediction, newPrediction: true });
    navigate("/prediction");
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowFilter((prev) => ({ ...prev, show: false }));
      }
    };

    if (showFilter.show) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showFilter.show]);

  const location = useLocation();
  return (
    <div className="bg_home flex flex-col pb-8">
      <div className="bg_home md:bg-[#F7F8FA] px-4 min-[955px]:px-40 flex flex-col pb-6 md:py-5">
        <div className="bg-white w-full rounded-xl shadow-sm p-3 md:p-5 overflow-hidden ">
          <div className="md:flex justify-between items-center w-full flex-wrap my-2 md:my-0 p-2">
            {}
            <div className="md:flex gap-2 my-2 md:my-0">
              {[
                // { name: "Completed Predictions" },
                { name: "My Live Predictions", path: "/prediction" },
                {
                  name: "Followed Predictions",
                  path: "/prediction/followed_prediction",
                },
              ]?.map((label, index) => (
                <div
                  key={index}
                  className={` text-[12px] border p-2 rounded-2xl cursor-pointer hover:shadow-sm transition-all flex gap-2 items-center my-2 md:my-0 max-w-[15rem] ${
                    label?.name === "Followed Predictions" &&
                    "bg-[#012169] text-white"
                  } `}
                  onClick={() => navigate(label.path)}
                >
                  <img
                    src={
                      label?.name === "Followed Predictions"
                        ? Prediction
                        : charticon
                    }
                    alt="chart-icon"
                    width={12}
                  />
                  {label?.name}
                </div>
              ))}
            </div>

            <div
              className={`text-[12px] border p-2 rounded-2xl cursor-pointer hover:shadow-sm transition-all flex gap-2 items-center max-w-[15rem] $`}
              onClick={handleNewPrediction}
            >
              <img src={charticon} alt="chart-icon" width={12} />
              New Prediction
            </div>
            {/* )} */}
          </div>
          <div className="flex justify-between items-center mt-3 px-2 mb-3">
            <div className="flex items-center">
              <FormControl sx={{ m: 1, width: "30ch" }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">
                  Search
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={"text"}
                  sx={{ borderRadius: "11px" }}
                  value={searchText}
                  onChange={handleInput}
                  onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                  endAdornment={
                    <InputAdornment position="end" onClick={handleSearch}>
                      <IconButton>
                        <img src={searchicon} alt="searchIcon" />
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Search"
                />
              </FormControl>
              <button
                className="px-4 py-2 border rounded-3xl text-white bg-[#012169]"
                onClick={handleReset}
              >
                <div className="flex items-center gap-1">
                  <p>Reset</p>
                </div>
              </button>
            </div>

            <div className="relative">
              <button
                className="px-4 py-2 border rounded-3xl text-white bg-[#012169]"
                onClick={() =>
                  setShowFilter((prev) => ({
                    ...prev,
                    show: !showFilter.show,
                  }))
                }
              >
                <div className="flex items-center gap-1">
                  <img src={filtericon} alt="filterIcon" width={15} />
                  <p>Filter</p>
                </div>
              </button>

              {showFilter.show && (
                <div
                  ref={filterRef}
                  className="absolute w-44 bg-[#F1F3F4] rounded-xl top-[50px] right-[0px] z-10 p-3 text-[12px] space-y-2 shadow-md"
                >
                  {[
                    { id: "most_followed", label: "Most Followed" },
                    { id: "most_commented", label: "Most Commented" },
                  ].map((item) => (
                    <div key={item.id} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        id={item.id}
                        name={item.id}
                        className="appearance-none w-4 h-4 border border-black rounded-sm 
                                checked:bg-black checked:border-black 
                                checked:after:content-['✔'] checked:after:text-white 
                                checked:after:text-[10px] checked:after:flex 
                                checked:after:items-center checked:after:justify-center"
                        onClick={handleFilter}
                      />
                      <label htmlFor={item.id} className="cursor-pointer">
                        {item.label}
                      </label>
                    </div>
                  ))}
                  <div className="flex justify-center mt-3">
                    <button
                      className="px-4 py-1 bg-[#E4002B] text-white rounded-xl"
                      onClick={handleApplyFilter}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
          {FollowedPredictionPostListingResponse?.length > 0 ? (
            <div className="my-3">
              {FollowedPredictionPostListingResponse?.map((entry) => {
                return (
                  <div className="my-5">
                    <UserPredictionListingComp
                      transformedData={entry?.result}
                      userData={entry?.user}
                      time={entry?.updatedAt}
                      likes={entry?.likes}
                      comments={entry?.comments}
                      description={entry?.description}
                      uuid={entry?.uuid}
                      isLiked={entry?.isLiked}
                      setRender={setRender}
                      isFollow={entry?.isFollow}
                      openCommentId={openCommentId}
                      setOpenCommentId={setOpenCommentId}
                      openShareId={openShareId}
                      setOpenShareId={setOpenShareId}
                    />
                  </div>
                );
              })}
            </div>
          ) : (
            <>
              <NothingFound />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FollowedPrediction;
